import { render, staticRenderFns } from "./promociones.vue?vue&type=template&id=22795a32"
import script from "./promociones.vue?vue&type=script&lang=js"
export * from "./promociones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports